<script lang="ts">
  import { isNoLableKey, isUrl, parseDynamicData } from '$shared/helpers/utils';
  import Table from './Table.svelte';
  import Form from './Form.svelte';
  import Section from './Section.svelte';
  import { EmptyLabelDefault } from '$provider/constants/global';
  import { transformListKey } from '$shared/helpers/ListKeyFormat';
  import type { DataListValue } from 'src/global';
  import FlexibleDataModelType from '$provider/lib/apis/models/FlexibleDataModelType';
  import ObjectListType from '../ObjectListType.svelte';

  interface Props {
    value: DataListValue;
    key: string;
    hide: boolean;
    isChild: boolean;
  }

  let {
    value,
    key,
    hide,
    isChild
  }: Props = $props();

  const isValueComp = (value: DataListValue): boolean => {
    return value && typeof value !== 'string' && !Array.isArray(value);
  };
</script>

<div class="co-form-i" class:isValueComp={isValueComp(value)} class:hide class:isChild>
  {#if !isNoLableKey(key)}
    <div data-cy={`${key}-k`} class="key">{transformListKey(key)}</div>
  {/if}
  {#if !value}
    <div class="value">{EmptyLabelDefault}</div>
  {:else if typeof value === 'string'}
    <div data-cy={`${key}-v`} class="value">
      {#if isUrl(value)}
        <a class="link" href={value} target="_blank">{value}</a>
      {:else}
        {parseDynamicData(value) || EmptyLabelDefault}
      {/if}
    </div>
  {:else if value?.type === FlexibleDataModelType.Table}
    <div class="comp"><Table isChild data={value?.data} /></div>
  {:else if value?.type === FlexibleDataModelType.Form}
    <div class="comp"><Form isChild data={value?.data} /></div>
  {:else if value?.type === FlexibleDataModelType.Section}
    <div class="comp"><Section data={value?.data} /></div>
  {:else if typeof value === 'object'}
    <div class="comp"><ObjectListType {value} /></div>
  {:else if Array.isArray(value) || Array.isArray(value?.actualValue)}
    <div class="form-array">
      {#each value as item}
        <div class="form-array-i">{item}</div>
      {/each}
    </div>
  {:else}
    <div class="invalid">Invalid object type, expected string or Table</div>
  {/if}
</div>

<style>
  .co-form-i {
    width: 100%;
    display: flex;
    align-items: flex-start;
    padding: 12px 16px;
    line-height: 20px;
  }
  .co-form-i.isChild {
    padding: 16px 0;
    background-color: transparent;
  }
  .co-form-i.hide {
    display: none;
  }
  .key {
    width: 150px;
    margin-right: 16px;
    flex-shrink: 0;
    font-weight: 500;
    color: var(--black);
  }
  .value {
    width: 100%;
    word-break: break-word;
  }
  .form-array {
    width: 100%;
    padding: 0;
    display: flex;
    flex-direction: column;
  }
  .form-array .form-array-i:not(:last-child) {
    margin-bottom: 8px;
  }
  .isValueComp {
    flex-direction: column;
  }
  .isValueComp > .key {
    font-weight: bold;
    margin-right: 0;
    width: auto;
  }
  .isValueComp > .comp {
    padding-left: 8px;
    width: 100%;
  }
</style>
